// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const HttpResponseBody = {
    json: (value) => {
        return {
            value: value,
            type: "json",
            _visit: function (visitor) {
                return FernIr.HttpResponseBody._visit(this, visitor);
            },
        };
    },
    fileDownload: (value) => {
        return Object.assign(Object.assign({}, value), { type: "fileDownload", _visit: function (visitor) {
                return FernIr.HttpResponseBody._visit(this, visitor);
            } });
    },
    text: (value) => {
        return Object.assign(Object.assign({}, value), { type: "text", _visit: function (visitor) {
                return FernIr.HttpResponseBody._visit(this, visitor);
            } });
    },
    bytes: (value) => {
        return Object.assign(Object.assign({}, value), { type: "bytes", _visit: function (visitor) {
                return FernIr.HttpResponseBody._visit(this, visitor);
            } });
    },
    streaming: (value) => {
        return {
            value: value,
            type: "streaming",
            _visit: function (visitor) {
                return FernIr.HttpResponseBody._visit(this, visitor);
            },
        };
    },
    streamParameter: (value) => {
        return Object.assign(Object.assign({}, value), { type: "streamParameter", _visit: function (visitor) {
                return FernIr.HttpResponseBody._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "json":
                return visitor.json(value.value);
            case "fileDownload":
                return visitor.fileDownload(value);
            case "text":
                return visitor.text(value);
            case "bytes":
                return visitor.bytes(value);
            case "streaming":
                return visitor.streaming(value.value);
            case "streamParameter":
                return visitor.streamParameter(value);
            default:
                return visitor._other(value);
        }
    },
};
